module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-13 col-sm-13"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form-text', {
    attrs: {
      "label": "Search Assets",
      "name": "searchassets"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == '2' || _vm.org['curOrg']['role'] == 99) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": ""
    }
  }, [_vm._v("Add")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('assets-table', {
    attrs: {
      "data": _vm.assets,
      "columns": _vm.gridColumns,
      "filter-key": _vm.searchQuery
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19341bec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/assets/Assets.vue
// module id = 606
// module chunks = 1